'use strict';

import { Entity } from '../Entity';

export class IndFlag extends Entity {
  protected indFlagId;

  protected indId;

  protected indFlagged;

  protected ind;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.indFlagId = data.indFlagId;

    this.indId = data.indId;

    this.indFlagged = data.indFlagged;

    this.ind = data.ind;
  }

  public getIndFlagId() {
    return this.indFlagId;
  }

  public getIndId() {
    return this.indId;
  }

  public getIndFlagged() {
    return this.indFlagged;
  }

  public getInd() {
    return this.ind;
  }
}
